import * as Yup from 'yup';

export default () => {
  return Yup.object().shape({});
};
